import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormContext } from '../context/FormContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CTAButton from '../components/CTAButton';
import SecurityBadges from '../components/SecurityBadges';

const NoInfo: React.FC = () => {
  const { nextStep } = useFormContext();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await nextStep({}); // No additional data to add, but we want to track the step
    navigate('/email');
  };

  const handleBack = () => {
    navigate('/known-info');
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow container mx-auto px-4 py-8 max-w-3xl">
        <div className="form-container fade-in">
          <h2 className="text-2xl text-center font-semibold text-deep-blue mb-8">
            Für die Adressrecherche ist die Angabe der letzten bekannten Straße & Hausnummer und/oder des Geburtsdatums erforderlich.
          </h2>
          
          <div className="mt-8 flex justify-center">
            <CTAButton 
              text="Zurück" 
              back={true} 
              onClick={handleBack}
              className="w-full md:w-auto" 
            />
          </div>
        </div>
        
        <SecurityBadges />
      </main>
      
      <Footer />
    </div>
  );
};

export default NoInfo;
